import { ContentCard } from 'components/Card/ContentCard';
import { ErrorFallbackScreen } from 'components/screens';
import { getTrans } from 'modules/i18n';
import {
  DEFAULT_TIMEZONE,
  getHoursAndMinutesLabel,
  getShortDateLabelWithTimezone
} from 'utils/date';
import { useAssignmentDetails } from '../hooks';
import { AssignmentDetailsSkeleton } from './AssignmentDetailsSkeleton';
import { DetailsDataItem } from './DetailsDataItem';

export const AssignmentDetails = () => {
  const { isLoading, assignmentDetails, isError } = useAssignmentDetails();

  if (isLoading) return <AssignmentDetailsSkeleton />;

  if (isError) return <ErrorFallbackScreen />;

  if (!assignmentDetails) return null;

  return (
    <ContentCard title={getTrans('assignmentDetailsPage.currAssignment.title')}>
      <DetailsDataItem
        label={getTrans('assignmentDetailsPage.company')}
        value={assignmentDetails.company}
        sx={{ pt: 1 }}
      />
      <DetailsDataItem
        label={getTrans('assignmentDetailsPage.location')}
        value={assignmentDetails.location}
      />

      <DetailsDataItem
        label={getTrans('assignmentDetailsPage.startDate')}
        value={getShortDateLabelWithTimezone(
          assignmentDetails.startDate,
          DEFAULT_TIMEZONE
        )}
      />
      <DetailsDataItem
        label={getTrans('assignmentDetailsPage.endDate')}
        value={getShortDateLabelWithTimezone(
          assignmentDetails.endDate,
          DEFAULT_TIMEZONE
        )}
      />
      <DetailsDataItem
        label={getTrans('assignmentDetailsPage.weeklyHours')}
        value={getHoursAndMinutesLabel(assignmentDetails.expectedPeriodMinutes)}
        sx={{ p: 0 }}
      />
    </ContentCard>
  );
};
